import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  makeStyles,
  Button,
} from "@material-ui/core";
import React from "react";
import { InformationRequestAction } from "../../../../domain/InformationRequestAction";
import { useDispatch } from "react-redux";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { cachedActionTypesService } from "../../../../services";
import { deleteAction } from "../../../../redux/actions";

const useStyles = makeStyles((theme) => ({
  actions: {
    padding: 15,
  },
}));

export const DeleteActionDialog: React.FC<{
  onClose: () => void;
  action: InformationRequestAction;
}> = ({ onClose, action }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleDeleteAction = () => {
    dispatch(deleteAction(action.informationRequestId, action.id));
    onClose();
  };

  const [actionTypesLookups] = useLookup(cachedActionTypesService);
  const actionType = actionTypesLookups.find((x) => x.id === action.actionType);

  const actionTypeName = actionType?.label;

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="delete-action-dialog"
    >
      <DialogTitle data-test="activity-title">Delete Action</DialogTitle>
      <Divider />
      <DialogContent>
        Are you sure you wish to delete the <strong>{actionTypeName}</strong>{" "}
        action?
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={onClose}
          color="primary"
          data-test="close-action-dialog"
        >
          Close
        </Button>
        <Button
          onClick={handleDeleteAction}
          color="primary"
          data-test="confirm-delete-action-button"
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
